import React from 'react'
import { connect } from 'react-redux'
import SortableOrdersTable from './SortableOrdersTable'

class ShopOrdersShow extends React.Component {
  componentDidMount() {
    this.props.dispatch({
      type: 'SHOP_ORDER_LOAD_SAGA',
      payload: { id: this.props.match.params.id }
    })
  }

  render() {
    return (
      <div className='shop-orders-show-table-wrapper'>
        <SortableOrdersTable noHeader/>
      </div>
    )
  }
} // ShopOrdersShow

const mapStateToProps = (state) => ({})
export default connect(mapStateToProps)(ShopOrdersShow)
